import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}), 'ErrorOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ErrorOutlined.js
// module id = 3389
// module chunks = 2